import { api } from '../client';

export interface AlertRule {
  _id: string;
  name: string;
  metric: string;
  operator: string;
  threshold: number;
  duration_minutes: number;
  severity: 'warning' | 'critical';
  recipients: Array<{ _id: string; username: string; email: string }>;
  cooldown_minutes: number;
  enabled: boolean;
  created_by?: { username: string };
  createdAt: string;
}

export interface AlertHistoryEntry {
  _id: string;
  rule_name: string;
  client_id: string;
  client_name: string;
  deployment_name?: string;
  metric: string;
  value: number;
  threshold: number;
  severity: string;
  notifications_sent: number;
  timestamp: string;
}

export type AlertRulePayload = Omit<Partial<AlertRule>, 'recipients'> & { recipients?: string[] };

export const alertsApi = {
  listRules: () =>
    api.get<{ success: boolean; rules: AlertRule[] }>('/api/alerts'),

  createRule: (data: AlertRulePayload) =>
    api.post<{ success: boolean; rule: AlertRule }>('/api/alerts', data),

  updateRule: (id: string, data: AlertRulePayload) =>
    api.put<{ success: boolean; rule: AlertRule }>(`/api/alerts/${id}`, data),

  deleteRule: (id: string) =>
    api.delete<{ success: boolean }>(`/api/alerts/${id}`),

  history: (params: { page?: number; limit?: number; search?: string; metric?: string; severity?: string } = {}) =>
    api.get<{ success: boolean; history: AlertHistoryEntry[]; total: number; page: number; totalPages: number }>(
      '/api/alerts/history', params as Record<string, string | number>
    ),

  thresholdViolations: (hours = 24) =>
    api.get<{ success: boolean; data: Array<{ hour: string; cpu: number; memory: number; disk: number }>; thresholds: { cpu: number; memory: number; disk: number } }>(
      '/api/analytics/threshold-violations', { hours }
    ),

  partnerApiStats: (hours = 24) =>
    api.get<{ success: boolean; perPartner: unknown[]; overall: unknown[] }>(
      '/api/analytics/partner-api-stats', { hours }
    ),
};
